import { useMemo } from 'react';

import { EnvironmentCountries, MultilingualCodeSystems } from '@e-origin/shared';

import { useSettings } from './useSettings';

export interface UseCodeListSystemParams {
  group?: string;
  isExport?: boolean;
  isTransit?: boolean;
}

export const useCodeListSystem = (params: UseCodeListSystemParams): MultilingualCodeSystems[] => {
  const { data: settings } = useSettings();
  const { group, isExport = false, isTransit = false } = params;

  return useMemo(() => {
    if (isTransit) return [MultilingualCodeSystems.NCTSP5];

    const systems: MultilingualCodeSystems[] = [];
    if (!isExport) systems.push(MultilingualCodeSystems.CCI);

    if (group === 'H1' && settings?.country === EnvironmentCountries.BE) {
      systems.push(isExport ? MultilingualCodeSystems.AES : MultilingualCodeSystems.IDMS);
    } else if (group === 'H1' && settings?.country === EnvironmentCountries.NL) {
      systems.push(isExport ? MultilingualCodeSystems.AES : MultilingualCodeSystems.DMS);
    }

    return systems;
  }, [group, isExport, isTransit, settings?.country]);
};
